import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { auth } from "../../../utils/auth";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";

class Usuarios extends Component {
    state = {
        usuarios: {},
        usuario: {},
        links: null,
        meta: null,
        showCreate: false,
        showEdit: false,
    };
    componentDidMount() {
        this.getUsers();
    }
    getUsers = async (url = null) => {
        url = url ? url : "usuarios";
        const usuarios = await this.props.request(url);

        if (usuarios.links) {
            this.setState({
                usuarios: usuarios.data,
                links: usuarios.links,
                meta: usuarios.meta,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            usuario: {},
        });
    };
    toggleEditModal = (usuario) => {
        this.setState({
            showEdit: !this.state.showEdit,
            usuario: usuario,
        });
    };
    render() {
        const { usuarios } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Usuarios</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Usuario
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {!usuarios.length ? (
                                <Loader />
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Usuario</th>
                                                <th className='text-center'>
                                                    Activo
                                                </th>
                                                <th>Rol</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {usuarios
                                                .filter((usr) =>
                                                    auth.is("super-admin")
                                                        ? true
                                                        : usr.rol !==
                                                          "super-admin"
                                                )
                                                .map((usr) => {
                                                    return (
                                                        <tr
                                                            className='tr-shadow'
                                                            key={usr.id}>
                                                            <td>
                                                                {usr.nombre}{" "}
                                                                {usr.apellido}
                                                            </td>
                                                            <td>
                                                                {usr.usuario}
                                                            </td>
                                                            <td className='text-center'>
                                                                <span
                                                                    className={`status ${
                                                                        usr.estado
                                                                            ? "active"
                                                                            : ""
                                                                    }`}
                                                                />
                                                            </td>
                                                            <td>
                                                                <span className='role user'>
                                                                    {usr.rol}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className='table-data-feature'>
                                                                    <button
                                                                        className='item'
                                                                        data-toggle='tooltip'
                                                                        data-placement='top'
                                                                        title=''
                                                                        data-original-title='Edit'
                                                                        onClick={() => {
                                                                            this.toggleEditModal(
                                                                                usr
                                                                            );
                                                                        }}>
                                                                        <i className='zmdi zmdi-edit' />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            {this.state.links && (
                                <Pagination
                                    links={this.state.links}
                                    meta={this.state.meta}
                                    getData={this.getUsers}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        usuario={this.state.usuario}
                        getUsers={this.getUsers}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        usuario={this.state.usuario}
                        getUsers={this.getUsers}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Usuarios);
